/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseCarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/base-carousel.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';

export const CarouselFragment = gql`
  ${BaseCarouselFragment}
  ${BaseLinkFragment}

  fragment CarouselFragment on Carousel {
    ...BaseCarouselFragment

    viewAllLink {
      ...BaseLinkFragment
    }
  }
`;
